import api from "./api";
import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie'; // 👈 importar
import { useNavigate } from 'react-router-dom';

export const getAccessToken = () => {
    return sessionStorage.getItem("accessToken");
};


export const login = async (email, password) => {
    try {
      const response = await api.post("/login/", { email, password });
  
      const { access, refresh } = response.data;
  
      // Guardar tokens en cookies persistentes
      Cookies.set("accessToken", access, { expires: 1 });  // 1 día
      Cookies.set("refreshToken", refresh, { expires: 7 }); // 7 días
  
      return { success: true };
    } catch (err) {
      return {
        success: false,
        message: err.response?.data?.error || "Error al iniciar sesión",
      };
    }
  };
  
  export const logout = () => {
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");
  };

const useLogout = () => {
    const navigate = useNavigate();
  
    const logout = async () => {
      try {
        await api.post("/logout/");
        //sessionStorage.removeItem("accessToken");
        //sessionStorage.removeItem("user");
  
        // Redirige al login después de cerrar sesión
        //navigate("/");
        //navigate("/Login"); // Cambia la ruta según tu necesidad
        console.log("Sesión cerrada exitosamente");
      } catch (error) {
        console.error("Error al cerrar sesión:", error);
      }
    };
  
    return logout;
  };

export const getUserFromToken = () => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) return null;
    try {
        return jwtDecode(token);
    } catch (error) {
        return null;
    }
};



export const resetPassword = async (token, newPassword) => {
    try {
        const response = await api.post(`/auth/reset-password/${token}/`, {
            new_password: newPassword,
        });
        return response.data; // Retorna los datos si la solicitud es exitosa
    } catch (error) {
        throw error.response?.data || { message: 'Error desconocido' }; // Lanza el error para manejarlo en el componente
    }
};

export default useLogout;